import { Remark } from '../../HbtPortfolioManagement/components/HbtPortfolioManagementRequestOverview/components/Flyout/types';

export const isRemarkOther = (remark: Remark) => {
  const remarkOther = 999;
  if (!remark.remarkID) {
    return false;
  }
  return remark.remarkID % 1000 === remarkOther;
};
